var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___RjFrcG",
  "V8": "GuildFolderItem.module__relative___RjFrcG",
  "o6": "GuildFolderItem.module__collapsedFolder___RjFrcG",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___RjFrcG",
  "sD": "GuildFolderItem.module__miniGuildIcon___RjFrcG",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___RjFrcG",
  "mw": "GuildFolderItem.module__folderBadge___RjFrcG",
  "M8": "GuildFolderItem.module__folderBadgeActive___RjFrcG",
  "k9": "GuildFolderItem.module__expandedFolderBackground___RjFrcG",
  "MJ": "GuildFolderItem.module__folderHeader___RjFrcG",
  "mK": "GuildFolderItem.module__folderHeaderButton___RjFrcG",
  "Eh": "GuildFolderItem.module__folderIcon___RjFrcG",
  "QD": "GuildFolderItem.module__expandedGuilds___RjFrcG",
  "h5": "GuildFolderItem.module__folderTooltipContainer___RjFrcG",
  "bO": "GuildFolderItem.module__folderTooltipName___RjFrcG",
  "Il": "GuildFolderItem.module__dropIndicatorTop___RjFrcG",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___RjFrcG",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___RjFrcG",
};

module.exports = exports;
